//This service is responsible for getting certain options from the server
(function () {
    'use strict';

    angular
        .module('app')
        .factory('optionsService', optionsService);

    optionsService.$inject = ['$http', '$q', '$localStorage'];

    function optionsService($http, $q, $localStorage) {
        var service = {
            //viewer options, returns a promise
            getViewerOptions: getViewerOptions
        };

        return service;
        //Viewer options
        function getViewerOptions() {
            var deferred = $q.defer();
            //if the options are not available, get them from the server
            if (!service.viewerOptions) {
                //initialize the object
                service.viewerOptions = {};
                //call to the server
                $http.get('../Synergis.WebApi/api/Configuration/ViewerOptions').then(function (response) {
                    //check to make sure we got the data, otherwise reject the call
                    if (response.data["NewViewer"] == "true") {

                        service.viewerOptions = response.data;
                        deferred.resolve(response.data);

                        var viewerSRE = response.data['ViewerServerRenderingExtensions'];
                        service.viewerOptions.viewerServerRenderingExtensions = viewerSRE ? viewerSRE.split(',') : null;

                        //Bill 02-25-22 Added white list of extensions
                        viewerSRE = response.data['ViewerWhiteListExtensions'];
                        service.viewerOptions.viewerWhiteListExtensions = viewerSRE;

                        //viewerWhiteListExtensions

                        deferred.resolve(service.viewerOptions);
                    }
                    else if (service.viewerOptions.codebase != "") {
                        service.viewerOptions.codebase = response.data['Codebase'];
                        service.viewerOptions.dms = response.data['DMS'];
                        service.viewerOptions.jVueServer = response.data['JVueServer'];
                        //service.viewerOptions.viewerClientPorts = response.data['ViewerClientPorts'];
                        service.viewerOptions.autoVueConvert = response.data['AutoVueConvert'];
                        service.viewerOptions.Viewer3DFileExtensions = response.data['Viewer3DFileExtensions'];
                        deferred.resolve(service.viewerOptions);
                    }
                    else {
                        deferred.reject(response);
                    }                    
                }, function (response) {
                    //in case of error
                    deferred.reject(service.viewerOptions);
                });
            }
            else {
                //resolve the cached options
                deferred.resolve(service.viewerOptions);
            }
            //returning a promise in case it's an async operation        
            return deferred.promise;
        }
    }
})();